module.exports = __webpack_public_path__ + "media/images/hitfun/welcome.logo-7da61efba7810384c5aba78618140814.svg";